import { Injectable, NgZone } from '@angular/core';
import posthog from 'posthog-js';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

export const POSTHOG_KEYS = {
  EDIT_SELL_TRN_LINKAGES: 'edit-sell-trn-linkages',
  EDIT_TRN: 'traceability-edit-trn',
  RISK_FILTER: 'traceability-shipment-table-risk-filter'
};

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private flagsLoaded = false;

  constructor(private readonly ngZone: NgZone) {
    this.initPostHog();
  }
  private initPostHog() {
    if (environment.posthogKey) {
      this.ngZone.runOutsideAngular(() => {
        posthog.init(environment.posthogKey, {
          api_host: environment.posthogHost,
          debug: false,
          cross_subdomain_cookie: true,
          capture_pageview: 'history_change'
        });
      });
    }
  }

  getFeatureFlag(key: string): Observable<boolean> {
    if (!environment.posthogKey) {
      return of(true);
    }

    if (this.flagsLoaded) {
      return of(posthog.isFeatureEnabled(key) ?? false);
    }

    return new Observable<boolean>((observer) => {
      posthog.onFeatureFlags(() => {
        this.flagsLoaded = true;
        observer.next(posthog.isFeatureEnabled(key) ?? false);
        observer.complete();
      });

      setTimeout(() => {
        if (!observer.closed) {
          console.warn('Timed out during feature flag retrieval from PostHog');
          observer.next(false);
          observer.complete();
        }
      }, 3000);
    });
  }
}
